import utils from "../utils/utils";

export function validatePhone($phone) {
    const locale = utils.get_locale();

    if (['nb_no', 'da_dk'].includes(locale)) {
        // Danish: 8 digits, starts with 2-9
        return /^[2-9]\d{7}$/.test($phone);
    } else if (locale === 'sv_se') {
        // Swedish: 7-10 digits, digits only, starts with 0
        return /^\d{7,10}$/.test($phone) && $phone[0] === '0';
    }
    return false;
}

export function validateEmail($email) {
    let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test($email);
}

export function getPartnerID() {
    const urlParams = new URLSearchParams(window.location.search);
    const get = Object.fromEntries(urlParams.entries());
    return get.ng_pid ? get.ng_pid : null;
}


$.fn.replaceOptions = function (options) {
    let self, $option;

    this.empty();
    self = this;

    $.each(options, function (index, option) {
        $option = $("<option></option>")
            .attr("value", option.value)
            .attr("name", option.name)
            .text(option.text);
        self.append($option);
    });
};

export function isTemplate(template) {
    return $('.page-template-' + template).length
}